/**
 * 签署-视频签署
 * 2018.09.19
 * rmh
 */
import GlobalConfig from '../config/global'
import ApiPort from '../config/api-port'
import HttpAxios from './http-axios'
import {handleError, handleResponse} from "../lib/common";
import qs from 'qs'

let junziqianApi = GlobalConfig.domain.junziqianApi;

export  default {

  /**
   * 获取视频签署结果列表
   * @param applyNo
   * @returns {Promise<T>}
   */
  getVideoSignList (applyNo) {
    var url = junziqianApi + ApiPort.videoSignApi.videoSignList
    var param = {applyNo: applyNo}
    return HttpAxios.get(`${url}?${qs.stringify(param)}`).then(handleResponse).catch(handleError)
  },

  /**
   * 初始化视频信息，用来判断客户端是否有视频设备
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  initRoomParam({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.initRoomParam
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.get(`${url}?${qs.stringify(param)}`).then(handleResponse).catch(handleError)
  },

  /**
   * 结束录制存证中的视频
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  finishVideoSign ({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.finishVideoSign
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.post(url, param).then(handleResponse).catch(handleError)
  },

  /**
   * 开始视频
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  startMix({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.startMix
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.post(url, param).then(handleResponse).catch(handleError)
  },

  /**
   * 进入视频签署房间
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  enterVidetSignRoom ({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.enterVidetSignRoom
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.post(url, param).then(handleResponse).catch(handleError)
  },

  /**
   * 进入视频签署等待房间
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  enterWaiteRoom ({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.enterWaitRoom
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.post(url, param).then(handleResponse).catch(handleError)
  },

  /**
   * 关闭签署等待室，在拒绝或用户关闭等待室时调用，返回结果为状态
   * @param applyNo
   * @returns {Promise<T>}
   */
  closeWaitRoom(applyNo) {
    var url = junziqianApi + ApiPort.videoSignApi.closeWaitRoom
    var param = {applyNo: applyNo}

    return HttpAxios.post(url, param).then(handleResponse).catch(handleError)
  },

  /**
   * 发起视频签署，返回结果为状态
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  initVideoSign({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.initVideoSign
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.post(url, param).then(handleResponse).catch(handleError)
  },

  /**
   * get 查询视频签署状态信息
   * @param signNo
   * @param applyNo
   * @returns {Promise<T>}
   */
  getVideoSignStatus ({signNo, applyNo}) {
    var url = junziqianApi + ApiPort.videoSignApi.getVideoStatus
    var param = {signNo: signNo, applyNo: applyNo}

    return HttpAxios.get(`${url}?${qs.stringify(param)}`).then(handleResponse).catch(handleError)
  },

  /**
   * get 查询用户是否有视频签署套餐时间, true=有
   * @returns {Promise<T>}
   */
  hasVideoPackage() {
    var url = junziqianApi + ApiPort.videoSignApi.hasVideoPackage

    return HttpAxios.get(url).then(handleResponse).catch(handleError)
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/video-sign.js